export default __webpack_public_path__ + "f185830b10e507e6d09b2c5d92f68e0e.png";